var config = {
    'share-selected-text': true,
    'load-more': false,
    'infinite-scroll': false,
    'infinite-scroll-step': 1,
    'content-api-url': 'https://kamilzawilski.pl',
    'content-api-key': '039de798850847b8f7f3e24740',
};